export default "__VITE_ASSET__DI46NAVV__"